import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import Grid from '@mui/material/Grid'
import DestinationPicker from './DestinationPicker'

const NearestPaediatrics = ({ destinationOptions, loadOptions }) => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={4}>
      <DestinationPicker
        value={medPlan?.nearestPaediatrics ?? null}
        label="Nearest Paediatric Hospital"
        type="Paediatrics"
        loadOptions={loadOptions}
        destinationOptions={destinationOptions}
        onChange={(e, newValue) => {
          setMedPlan((prev) => ({
            ...prev,
            nearestPaediatrics: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        onEditSubmit={(newValue) => {
          setMedPlan((prev) => ({
            ...prev,
            nearestPaediatrics: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
      />
    </Grid>
  )
}

export default React.memo(NearestPaediatrics)
